import React, {useEffect, useState} from "react";
import {ONE_WAY, ROUND_TRIP} from "../../../../utils/consts";
import OnewayIcon from "../../../../utils/svg/oneway-icon";
import RoundIcon from "../../../../utils/svg/round-icon";
import WarningIcon from "../../../../utils/svg/warning-icon";
import TrashIcon from "../../../../utils/svg/trash-icon";
import {getQuote, minutesToHours} from "../../../../utils/FlexxAPI";

const DesktopLeg = ({leg, index, onDelete, onUpdate}) => {
  const [trips, setTrips] = useState(0);
  const [type, setType] = useState(leg.tripType);
  const [lock, setLock] = useState(false);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setTrips(leg.trips);
    setType(leg.tripType);
  }, [leg])

  const handleTripUpdates = (e) => {
    const v = e.target.value <= 0 ? 1 : parseInt(e.target.value);
    setTrips(v);
    leg.trips = v;
    leg.total = leg.estimate * leg.trips;
    leg.total = leg.total.toFixed(2);
    onUpdate(leg, index)
  }

  const handleTripType = (val) => {
    if (lock) {
      return;
    }
    setLock(true);
    setType(val);
    setLoading(true);

    try {
      getQuote(leg.from, leg.to, val, leg.plane, null).then((response) => {
        if (response.error) {
          setLock(false);
          setLoading(false);
          return;
        }

        leg.trips = trips;
        leg.estimate = response.flight_time;
        leg.additional = 0;
        // leg.estimate = Math.ceil((response.flight_time / 60) * Math.pow(10, 2)) / Math.pow(10, 2);
        // leg.additional = Math.ceil((response.block_time / 60) * Math.pow(10, 2)) / Math.pow(10, 2);
        leg.total = leg.estimate * leg.trips;
        onUpdate(leg, index)
        setLock(false);
        setLoading(false);
      })
    } catch (e) {
      setLock(false);
      setLoading(false);
    }

  }


  return <>
    <tr key={index}>
      <td className="flight-calculator__inputs">
        <h6>{leg.from.iata ? leg.from.iata + ' |' : ''} {!!leg.from.name && <b>{leg.from.name}</b>}</h6></td><td>
      <div className="flight-calculator__trip">
        <div className="flight-calculator__trip__content">
          <div
            className={`flight-calculator__trip__button ${type === ONE_WAY ? 'active' : ''}`}
            onClick={() => { handleTripType(ONE_WAY) }}
          >
            <OnewayIcon/>
          </div>
          <div
            className={`flight-calculator__trip__button ${type === ROUND_TRIP ? 'active' : ''}`}
            onClick={() => { handleTripType(ROUND_TRIP) }}>
            <RoundIcon/>
          </div>
        </div>
      </div></td><td>
      <h6>{leg.to.iata ? leg.to.iata + ' |' : ''} {!!leg.to.name && <b>{leg.to.name}</b>}</h6>
      {!!leg.fuel_stop && <div className="flight-calculator__warning">
        <WarningIcon/>
        <p>Fuel stop(s) required</p>
      </div>}

    </td>
      <td className="time1">
        {/* {minutesToHours(leg.estimate, 1)} */}
        {loading ? 'loading..' : minutesToHours(leg.estimate, 1)}
        </td>
      <td>
        <input
          type="number"
          value={trips}
          min={1}
          onChange={handleTripUpdates}
        />
      </td>
      <td className="time2">
        {/* {minutesToHours(leg.estimate, leg.trips)} */}
        {loading? 'loading..' : minutesToHours(leg.estimate, leg.trips) }
        <span className='flight-calculator__trash' onClick={() => {
          onDelete(index);
        }}>
          <TrashIcon/>
        </span>
      </td>
    </tr>
  </>

}

export default DesktopLeg;
